export default __webpack_public_path__ + "static/media/hero-section-mobile.383ea624.png";